import { render, staticRenderFns } from "./AnomalyStatistics.vue?vue&type=template&id=537b9d24&scoped=true&"
import script from "./AnomalyStatistics.vue?vue&type=script&lang=ts&"
export * from "./AnomalyStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./AnomalyStatistics.vue?vue&type=style&index=0&id=537b9d24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537b9d24",
  null
  
)

export default component.exports